import { Link } from 'react-router-dom';
import { FC } from 'react';
import { t } from 'i18next';
import './style.css';

export const NotFound: FC = () => {
    return (
        <div className="not-found-container">
            <h1>{t('Common:pageNotFoundMessage')}</h1>
            <p>{t('Common:pageNotExistsMessage')}</p>

            <Link to="/" className="back-home-link">
                {t('Common:gotoHome')}
            </Link>
        </div>
    );
};
